import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiShoppingCart, FiSearch, FiMenu, FiX, FiHeart, FiUser } from "react-icons/fi";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css";

export default function Navbar() {
  const { count } = useCart();
  const { wishlist } = useWishlist();
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) { navigate(`/shop?search=${search}`); setSearch(""); setSearchOpen(false); setMenuOpen(false); }
  };

  return (
    <>
      <div className="announcement-bar">
        <span>🚚 Free Delivery on Orders &nbsp;|&nbsp; 🔄 Easy Returns &nbsp;|&nbsp; ✨ New Collection Now Live at RizzGlam</span>
      </div>

      <nav className="navbar">
        <div className="nav-container">
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>

          <Link to="/" className="logo">
            <div className="logo-brand">
              <span className="logo-main">Rizz</span><span className="logo-accent">Glam</span>
            </div>
            <span className="logo-sub">Browse &nbsp;·&nbsp; Shop by Category</span>
          </Link>

          <div className="nav-icons">
            <button className="icon-btn" onClick={() => setSearchOpen(!searchOpen)}><FiSearch /></button>
            <Link to="/wishlist" className="icon-btn cart-icon">
              <FiHeart />
              {wishlist.length > 0 && <span className="cart-badge">{wishlist.length}</span>}
            </Link>
            <Link to="/account" className="icon-btn">
              {user ? <span className="nav-avatar">{user.name?.[0]?.toUpperCase()}</span> : <FiUser />}
            </Link>
            <Link to="/cart" className="icon-btn cart-icon">
              <FiShoppingCart />
              {count > 0 && <span className="cart-badge">{count}</span>}
            </Link>
          </div>
        </div>

        {searchOpen && (
          <div className="search-dropdown">
            <form onSubmit={handleSearch} className="search-form">
              <FiSearch className="search-icon-inner" />
              <input autoFocus value={search} onChange={e => setSearch(e.target.value)} placeholder="Search for lawn suits, kurtis, accessories..." />
              <button type="submit">Search</button>
              <button type="button" className="close-search" onClick={() => setSearchOpen(false)}><FiX /></button>
            </form>
          </div>
        )}

        {menuOpen && (
          <div className="mobile-menu">
            <form onSubmit={handleSearch} className="mobile-search">
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..." />
              <button type="submit"><FiSearch /></button>
            </form>
          </div>
        )}
      </nav>
    </>
  );
}
